export default __webpack_public_path__ + "static/media/AI-campus.a09f0cb4.png";